import React from 'react';



export default function BuyerMapEd() {

  return (
    <>
        <h1> КАРТА ПОТРЕБИТЕЛЬСКОЙ ПОЛЕЗНОСТИ </h1>
        <p>Карта потребительской полезности – инструмент, который в общем виде отображает опыт взаимодействия клиентов с продуктом и раскрывает проблемы, которые отрасль не смогла решить, создав тем самым болевые точки.</p>
        <img src={`${process.env.PUBLIC_URL}/images/2. buer-ru.jpg`} style={{width: 600}}/>
        <h3>
          Карта потребительской полезности состоит из следующих элементов:
        </h3>
        <p>
          1. В строках размещаются этапы покупательского цикла. Традиционно их выделяют шесть: покупка, доставка, использование, дополнительные продукты и услуги, обслуживание, утилизация. Этапы можно изменять с учетом особенностей отрасли.
        </p>

        <p>
          2. В столбцах расположены шесть рычагов полезности: продуктивность, простота, удобство, снижение риска, развлечение и имидж, дружественность по отношению к окружающей среде – с их помощью компании могут создать для покупателя исключительную ценность. Пересечение 6 этапов покупательского цикла и 6 рычагов полезности дает 36 возможных вариантов, или ниш, полезности.

        </p>

        <p>
          3. Строки можно поменять со столбцами, если так будет удобнее для восприятия и работы с инструментом.

          Цель инструмента – определить какие проблемы потребителя отрасль не смогла решить, тем самым выявив скрытые возможности для выхода из конкурентной среды и увеличения размера рынка.
        </p>

        <h3>
          Алгоритм работы с инструментом:
        </h3>

        <p>
          1. Опишите опыт взаимодействия потребителей с вашим продуктом с помощью этапов покупательского цикла.
        </p>
        <p>
          2. Определите действия, которые потребитель совершает на каждом из этапов покупательского цикла.
        </p>
        <p>
          3. Исследуйте шесть рычагов полезности. Передвигаясь от одного этапа цикла к другому, определите болевые точки потребителей.
        </p>
        <p>
          4. Заполните карту потребительской полезности – разместите болевые точки и опишите причины их существования, а также обозначьте нишу полезности, на которой в настоящее время фокусируется отрасль.
        </p>

        <h3>
          Правила работы с инструментом:
        </h3>

        <p>
          1. Для определения болевых точек, на пересечении всех этапов покупательского цикла и рычагов полезности ответьте на два вопроса: «Какое самое серьезное препятствие в обеспечении данного рычага полезности есть на этом этапе?» и «В чем основные причины этого препятствия?».
        </p>
        <p>
          2. Для четкого представления о том, что означают рычаги полезности, ознакомьтесь с кратким описанием каждого из них.
        </p>
          <p>
            - Потребительская продуктивность – все, что имеет отношение к эффективности в процессе удовлетворения нужд потребителей (меньше времени, усилий и (или) денег).
          </p>

          <p/>
          - Простота – все, что устраняет сложности при использовании продукта.

          <p/>
          - Удобство – когда и где потребителю необходим продукт – например, 24 часа в сутки 7 дней в неделю, на протяжении всего года.
          <p/>
          - Снижение риска – финансового, физического и эмоционального риска, в том числе репутационного.
          <p/>
          - Развлечение и имидж – это может быть общая эстетика продукта (осязаемая и неосязаемая), ощущение, характер и стиль, свойственные продукты.
          <p/>
          - Экологичность – этот рычаг связан с вопросами экологии: экологической безопасностью продукта, высокой репутации вашей компании в сфере охраны окружающей среды и так далее.


        <p/>
          <em>
            Пример – Карта потребительской полезности электрических бытовых фритюрниц до появления фритюрницы ActiFry компании Groupe SEB
          </em>

        <p>
          Несмотря на высокий уровень конкуренции в отрасли электрических бытовых фритюрниц, отрасль была сфокусирована только на одной из 36 ниш полезности – на эффективности в эксплуатации. Другими словами, на создании недорогой, надежной работающей электрической фритюрницы для приготовления картофеля фри. При этом отрасль упускала другие проблемы. Приготовление свежего картофеля фри требует жарки и большого количества масла, которое обходится дорого. Его нагревание делает прибор опасным. Масло трудно утилизировать, что затрудняет процесс очистки. Вдобавок ко всему масло делает картофель фри вредным для здоровья и чрезвычайно калорийным продуктом.
        </p>
        <p>
          Компания Groupe SEB, обнаружив эти болевые точки, которые долго оставались незамеченными, и учтя их при разработке продукта, создала инновационную фритюрницу. Для приготовления картофеля в этой фритюрнице его не требуется жарить в большом количестве масла. Достаточно всего одной столовой ложки, чтобы приготовить килограмм картофеля, и в нем будет на 40% меньше калорий и на 80% меньше жира, чем в такой же порции традиционного картофеля фри. Кроме того, прибор легко поддается очистке и не создает проблем с безопасностью или утилизацией масла. В итоге вы получаете выигрышное сочетание здорового, низкокалорийного, но все же очень вкусного картофеля.
        </p>
        <p>
          Пересмотрев проблему, на которой была сфокусирована отрасль, и изменив ее суть, Groupe SEB предложила потребителям скачок ценности, тем самым вдохновив стать клиентами компании тех людей, кто прежде даже не задумывался о покупке фритюрницы, что почти на 40% увеличило общий спрос в отрасли.
        </p>

    </>
  )
}
